<div class="nxe-view-switcher">
    @for (item of views; track $index) {
        <button (click)="setView(item.name)" [class.active]="currentView == item.name"><i class="{{ item.icon }}"></i></button>
    }
</div>
